import { createAction } from 'redux-actions';

export const getSwapsRequest = createAction('GET_SWAPS_REQUEST');
export const getSwapsSuccess = createAction('GET_SWAPS_SUCCESS');
export const getSwapsFail = createAction('GET_SWAPS_FAIL');

export const updateSwapsRequest = createAction('UPDATE_SWAPS_REQUEST');
export const updateSwapsSuccess = createAction('UPDATE_SWAPS_SUCCESS');
export const updateSwapsFail = createAction('UPDATE_SWAPS_FAIL');
